import type { FieldErrors } from "react-hook-form";
import { PRESET_POINTS, PUBLISHED_EDITABLE_FIELDS } from "../data/surveyForm.constants";
import type { SurveyEditableField, SurveyFormProps } from "../types/surveyForm.types";
import type { SurveyFormValues } from "../types/survey.types";

export const canEditSurveyField = (field: SurveyEditableField, isPublished: boolean) => {
  if (!isPublished) {
    return true;
  }

  return PUBLISHED_EDITABLE_FIELDS.includes(field);
};

export const formatSurveyCategoryLabel = (value: string) =>
  value.replace("_", " ").replace(/\b\w/g, (letter) => letter.toUpperCase());

export const getSurveyDisabledFields = (
  disabledFields: SurveyFormProps["disabledFields"],
  isPublished: boolean,
) => ({
  ...disabledFields,
  title: disabledFields?.title ?? !canEditSurveyField("title", isPublished),
  description: disabledFields?.description ?? !canEditSurveyField("description", isPublished),
  category: disabledFields?.category ?? !canEditSurveyField("category", isPublished),
  points: disabledFields?.points ?? !canEditSurveyField("points", isPublished),
  endTime: disabledFields?.endTime ?? !canEditSurveyField("endTime", isPublished),
});

export const getSurveyPointsErrorMessage = (errors: FieldErrors<SurveyFormValues>) =>
  errors.points?.message;

export const isPresetSurveyPoints = (points: number) =>
  PRESET_POINTS.includes(points as (typeof PRESET_POINTS)[number]);
